import { render, staticRenderFns } from "./MarketCustomerNew.vue?vue&type=template&id=296f15c6&"
import script from "./MarketCustomerNew.vue?vue&type=script&lang=js&"
export * from "./MarketCustomerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports